import type { IMetadataRepository, ProjectMetadataAdoptionsListOptions } from '../repositories/IMetadataRepository.js';
import type { ProjectMetadataAdoptionEntity } from '../entities/ProjectMetadataAdoptionEntity.js';

interface Deps { metadataRepository: IMetadataRepository; }
export function createListProjectMetadataAdoptionsUseCase({ metadataRepository }: Deps) {
  return function listProjectMetadataAdoptions(options: ProjectMetadataAdoptionsListOptions): Promise<ProjectMetadataAdoptionEntity[]> {
    return metadataRepository.listProjectAdoptions(options);
  };
}
